import { render, staticRenderFns } from "./MainNavi.vue?vue&type=template&id=63b2e0cf&scoped=true"
import script from "./MainNavi.vue?vue&type=script&lang=js"
export * from "./MainNavi.vue?vue&type=script&lang=js"
import style0 from "./MainNavi.vue?vue&type=style&index=0&id=63b2e0cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2e0cf",
  null
  
)

export default component.exports